import { Injectable } from '@angular/core';
import { Driver } from '../models/driver';
import { from } from 'rxjs';
import { filter } from 'rxjs/operators';

import * as _ from 'lodash';
import { forEach } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {
  formatMessages(e): string {
    var msg = "";

    if (e.status == 400) {
      console.log(e.error);
      msg = e.error.error;
    } else {
      for(let err in e.error.errors) {
        msg += e.error.errors[err] + "</br>";
      }
    }
    
    return msg;
  }

  getDateString(dateObj:Date) : string {
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();

    return year + "/" + month + "/" + day;
  }

  getDateFromString(d:string) : Date {
    var a = d.split('-');
    var month = Number(a[1]) - 1; //months from 1-12
    var day = Number(a[2]);
    var year = Number(a[0]);

    return new Date(year, month, day);
  }

  /**
   * Convierte una hora en formato de string (1h 35 min o 35 min) a segundos
   * @param time Tiempo en string
   * @returns representacion en segundos.
   */
  timeStringToInt(time:string): number  {
    let hour:number = 0, min:number = 0;
    if(time.indexOf('h') != -1) {
      hour = Number(time.split('h')[0]);
    }
    if(time.indexOf('min') != -1) {
      let minstr = time.split('h').length == 1 ? time.split('h')[0].trim() : time.split('h')[1].trim();
      min = Number(minstr.split(' min')[0]);
    }

    return hour*60 + min;
  }

  /**
   * Convierte una distancia en formato string a metros
   * @param distance distancia en string
   * @returns representacion en metros
   */
  distanceStringToInt(distance:string): number  {
    if(distance.indexOf('km') != -1) {
      return Number(distance.substring(0, distance.length - 3).replace('.', '').replace(',', '.')) * 1000;
    } else if(distance.indexOf('m') != -1) {
      return Number(distance.substring(0, distance.length - 3));
    }

    return 0;
  }

  dynamicSort(property:string) {
    var sortOrder = 1;
    if(property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return (a,b) => {
      let aa = this.getValueFromProperty(a, property);
      let bb = this.getValueFromProperty(b, property);
      var result = (aa < bb) ? -1 : (aa > bb) ? 1 : 0;
      return result * sortOrder;
    }
  }

  getValueFromProperty(value:string, property:string) {
    let pr = property.split('.');
    for(let i = 0; i < pr.length; i++) {
      value = value[pr[i]];
    }
    return value;
  }

  filterBy (data:any[], property:string, values:any[]) {
    //property: customer.name
    //values: array 
    if (values.length == 0) {
      return data;
    }
    return data.filter(dataV => {
      let v = this.getValueFromProperty(dataV, property);
      return values.find(d => d == v);
    })
  }

  createFilter(arr: string[], name: string): void {
    if (!arr.find(a => a == name)) {
      arr.push(name);
    }
  }

  filterDriverBy(drivers:Driver[],by:string,find:string = '',callback){
    switch (by) {
      case 'status':
        return this.filterStatus(drivers,find,callback);
      case 'name':
        return this.filterName(drivers,find,callback);
      case 'statistics':
        return this.filterStatus(drivers,find,callback,by);
    }
  }

  filterStatus(drivers:Driver[],find:string,callback,percent?:string){
    let driversTemp = [];
    from(drivers).pipe(
			filter(driver=>{
				switch(find) {
          case 'all':
            return driver.active || !driver.active;
					case 'active':
						return driver.active;
					case 'inactive':
						return !driver.active;
				}
			})
    ).subscribe(driver=>driversTemp.push(driver));
    (percent)?callback(Number(driversTemp.length/drivers.length)):callback(driversTemp);
  }

  filterName(drivers:Driver[],find:string,callback){
    let driversTemp = [];
    from(drivers).pipe(filter(driver=>{
          let nameLastName = ((driver.name + ' ' + driver.last_name).substring(0, find.length).toLowerCase());
          let lasNameName = ((driver.last_name + ' ' + driver.name).substring(0, find.length).toLowerCase());
          return nameLastName == find.toLowerCase()||lasNameName == find.toLowerCase();
    })).subscribe(driver=>driversTemp.push(driver));
    callback(driversTemp);
  }

  search(data:any[], columns:string[], find:string, uniqBy:string, callback){
    let dataTemp = [];
    _.forEach(columns, col => {
      _.forEach(_.filter(data, da=> da[col].toString().toLocaleLowerCase().indexOf(find.toLocaleLowerCase()) >= 0), t => dataTemp.push(t));
    });
    callback(_.uniqBy(dataTemp, uniqBy));
  }

  filterByParams(data:any[], brands:any[], customers:any[], products:any[], destination:string, callback){
    let dataTemp = [];
    if(brands){
        _.forEach(brands, (b) => {
          _.forEach(data, d => { (d.brand == b.id) ? dataTemp.push(d) : null});
      });
    }

    if(customers){
      _.forEach(customers, c => {
        _.forEach(data, d => { (d.target_customer == c.id) ? dataTemp.push(d) : null});
      })
    }

    if(products){
      _.forEach(products, (p) => {
        _.forEach(data, d => { (d.product_name == p.id) ? dataTemp.push(d) : null})
      })
    }

    if(destination){
      _.forEach(_.filter(data, d => d.target_customer_address.toString().toLocaleLowerCase().indexOf(destination.toLocaleLowerCase()) >= 0), t => dataTemp.push(t));
    }

    if(dataTemp.length > 0)
      callback(_.uniqBy(dataTemp, 'id'));
    else
      callback(_.uniqBy(data, 'id'));
    
  }

  filterByRoutes(data:any[], dirOrigen: any[], dirDestino: any[], callback){
    let dataTemp = [];

    //Direccion origen
    if(dirOrigen){
      _.forEach(dirOrigen, o => {
        console.log(o);
        _.forEach(data, t => {
          if(t.source_customer_address_id == o)
            dataTemp.push(t);
        })
      })
    }

    //Direccion destino
    if(dirDestino){
      _.forEach(dirDestino, d => {
        _.forEach(data, t => {
          if(t.target_customer_address_id == t)
            dataTemp.push(t);
        })
      })
    }

    callback(dataTemp);
  }
}
